import { SVGProps } from 'react';

const SvgHamburger = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 20" {...props}>
        <path d="M0 1.485C0 .665.665 0 1.485 0H23.73a1.485 1.485 0 0 1 0 2.97H1.485C.665 2.97 0 2.305 0 1.485ZM0 10c0-.82.665-1.485 1.485-1.485H15.15a1.485 1.485 0 1 1 0 2.97H1.485C.665 11.485 0 10.82 0 10ZM0 18.515c0-.82.665-1.485 1.485-1.485h6.667a1.485 1.485 0 1 1 0 2.97H1.485C.665 20 0 19.335 0 18.515Z" />
    </svg>
);
export default SvgHamburger;
